
import React from 'react';
import { PricingPlan } from '../types/pricingTypes';

interface PricingPlansProviderProps {
  user: any;
  isSubscribed: boolean;
  children: (plans: PricingPlan[]) => React.ReactNode;
}

export const PricingPlansProvider = ({ user, isSubscribed, children }: PricingPlansProviderProps) => {
  const getFreePlanButtonText = () => {
    if (!user) return "Sign Up";
    if (isSubscribed) return "Current Plan"; 
    return "Current Plan";
  };

  const getProPlanButtonText = () => {
    if (!user) return "Sign Up First";
    if (isSubscribed) return "Active Subscription";
    return "Subscribe Now";
  };

  const pricingPlans: PricingPlan[] = [
    {
      name: "Free",
      price: "$0",
      period: "forever",
      description: "Basic features for personal use",
      features: [
        "3 refund requests per month",
        "Basic tone presets"
      ],
      buttonText: getFreePlanButtonText(),
      buttonVariant: "outline",
      highlighted: false,
      disabled: true
    },
    {
      name: "Pro",
      price: "$10",
      period: "per month",
      description: "Advanced features for power users",
      features: [
        "Unlimited refund requests",
        "Advanced tone control",
        "Platform-specific intelligence for major stores",
        "Flight compensation claims",
        "Priority support"
      ],
      buttonText: getProPlanButtonText(),
      buttonVariant: "default",
      highlighted: true,
      disabled: isSubscribed
    }
  ];

  return <>{children(pricingPlans)}</>;
};
